import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgNote = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.526 21c.559 0 1.093-.228 1.479-.63l3.792-3.95c.365-.381.57-.89.57-1.42V6.836A3.81 3.81 0 0 0 16.71 3H8.944l-.09.001a3.75 3.75 0 0 0-3.67 3.834v10.508A3.746 3.746 0 0 0 8.945 21z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.01 20.938v-2.893a2.56 2.56 0 0 1 2.554-2.56h2.739M3.633 16.967h3.325m-3.325-4.966h3.325M3.633 7.035h3.325"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgNote);
export default ForwardRef;
